import Archives from './Archives'
export default Archives